import * as React from "react";
import { AsyncActionButton } from "../../misc/components/AsyncActionButton";
import { CloseInteractionModalAction, DevicesAction, SetInteractionModalStepAction } from "../DevicesNewReducer";
import * as P230In2itiveApi from '../../misc/api/DeviceLinkApi/P230In2itive';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUndo } from "@fortawesome/free-solid-svg-icons";

interface ResetSelectionProps {
    dispatch?: React.Dispatch<DevicesAction>;
}

export const ResetSelection = (props: ResetSelectionProps) => {
    const [selectedOption, setSelectedOption] = React.useState();
    const [subject, setSubject] = React.useState<string>();
    const [submitting, setSubmitting] = React.useState(false);

    React.useEffect(() => {
        const getSubject = async () => {
            const selectedDevice = await P230In2itiveApi.ReConnectToDevice();
            const subjectResult = await P230In2itiveApi.GetSubject(selectedDevice.id);

            if (subjectResult)
                setSubject(subjectResult.subject.number);

        }

        getSubject();
    }, []);

    const handleChange = (e) => {
        setSelectedOption(e.target.value);
    }

    const handleNavigation = async (step) => {
        setSubmitting(false);
        props.dispatch(SetInteractionModalStepAction.create(step));
    }

    const handleClose = () => {
        props.dispatch(CloseInteractionModalAction.create());
    }

    const next = () => {
        setSubmitting(true);
        switch (selectedOption) {
            case "ResetConfigurationOption":
                return handleNavigation(21);
            case "ResetToFactorySettingsOption":
                break;
        }
    }

    return (
        <div id="ActionSelection">
            <div className="modal-header bg-primary">
                <h3 className="modal-title">Manage Device</h3>
            </div>
            <div className="modal-body">
                <h2 className="text-primary">Action</h2>
                <p style={{ marginBottom: 15 + 'px' }} className="text-muted">Select which action to perform for this device</p>
                <ul className="posh-select">
                    <li key="ResetConfigurationOption">
                        <input id="ResetConfigurationOption" type="radio" name="action" value="ResetConfigurationOption" checked={selectedOption === "ResetConfigurationOption"} onChange={handleChange} />
                        <label htmlFor="ResetConfigurationOption">
                            <span className="posh-select-icon"><FontAwesomeIcon icon={faUndo} aria-hidden="true" /></span>
                            <span className="posh-select-body">
                                <span className="posh-select-title">{subject ? `Reset diary for subject ${subject}?` : "Reset diary"}</span>
                                <span className="posh-select-description text-muted">Confirm resetting of the subject configuration on the diary and remove association of this subject with the diary</span>
                            </span>
                        </label>
                    </li>
                </ul>
            </div>
            <div className="modal-footer">
                <AsyncActionButton
                    disabled={!selectedOption || submitting}
                    className="btn btn-primary"
                    isSubmitting={submitting}
                    onClick={next}
                >
                    Next
                </AsyncActionButton>
                <button className="btn btn-primary btn-outline" onClick={handleClose}>Cancel</button>
            </div>
        </div>
    );
}
